import { useCallback, useMemo } from 'react';
import { ConfirmModalParams } from '@rainbow-modules/app/lib/actions';
import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';

const useConfirmModal = (modalId: string) => {
    const modalProps = useConnectModal(modalId);
    const [openModal, closeModal] = useOpenModal(modalId);

    const handleConfirm = useCallback(
        (params: ConfirmModalParams) => new Promise<{ reason?: string; confirm?: boolean }>(
            (resolve) => {
                openModal({
                    ...params,
                    onSubmit: (values: Record<string, unknown>) => {
                        closeModal();
                        return resolve({ confirm: true, reason: values.reason as string });
                    },
                    onRequestClose: () => {
                        closeModal();
                        return resolve({ confirm: false });
                    },
                });
            },
        ),
        [closeModal, openModal],
    );

    return useMemo(() => ({
        modalProps,
        confirm: handleConfirm,
    }), [modalProps, handleConfirm]);
};

export default useConfirmModal;
